var _path, _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "-1 -1 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "none",
    d: "M15.366 12.313l4.314-3.728c.61-.53.295-1.566-.505-1.61l-5.555-.353c-.337-.022-.632-.242-.758-.573L10.821.579c-.295-.772-1.326-.772-1.62 0L7.158 6.027c-.126.33-.42.551-.758.573l-5.576.353c-.8.044-1.116 1.08-.505 1.61l4.314 3.706c.252.22.379.595.294.926l-1.41 5.668c-.189.794.632 1.434 1.305.993l4.693-3.154c.295-.199.652-.199.926 0l4.714 3.154c.673.44 1.494-.199 1.305-.993l-1.41-5.646c-.064-.33.042-.684.315-.904z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-empty",
    x1: 0,
    x2: "100%",
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d0d0d0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-filled-gradient-1",
    x1: 0,
    x2: "100%",
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "33%",
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d0d0d0"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-filled-gradient-2",
    x1: 0,
    x2: "100%",
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#d0d0d0"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-filled-gradient-3",
    x1: 0,
    x2: "100%",
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "66%",
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#d0d0d0"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "star-filled",
    x1: 0,
    x2: "100%",
    y1: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.53bd3bbadd6769a58eb55aaf6b95a3eb.svg";
export { ForwardRef as ReactComponent };